import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import feedbackService from "./feedbackService";

interface FeedBackI {
  subject: string;
  body: string;
  header: string;
}

interface FeedbackState {
  isLoading: boolean;
  isSuccessful: boolean;
  // error: AxiosError | null,
  feedback: FeedBackI;
}

const initialState: FeedbackState = {
  isLoading: false,
  isSuccessful: false,
  // error: null,
  feedback: {
    subject: "",
    body: "",
    header: "",
  },
};

export const sendFeedback = createAsyncThunk(
  "feedback",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await feedbackService.feedback(data);
      if (response.status === 200) {
        toast.success(response?.data.message);
      } else {
        toast.error(response?.data?.statusMessage);
      }
      return response.data;
    } catch (error) {
      const err = error as AxiosError<{ message: string }>;
      toast.error(err.response?.data.message);
      return rejectWithValue(err?.response?.data);
    }
  }
);

export const WhistleBlowing = createAsyncThunk(
  "whistle",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await feedbackService.whistleBlowing(data);
      if (response.status === 200) {
        toast.success(response?.data.statusMessage);
      } else {
        toast.error(response?.data?.statusMessage);
      }
      return response.data;
    } catch (error) {
      const err = error as AxiosError<{ message: string }>;
      toast.error(err.response?.data.message);
      return rejectWithValue(err?.response?.data);
    }
  }
);

export const feedbackSlice = createSlice({
  name: "feedback",
  initialState,
  reducers: {
    noTract: () => {},
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendFeedback.pending, (state, action) => {
        return {
          ...state,
          isLoading: true,
          isSuccessful: false,
        };
      })
      .addCase(sendFeedback.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
        };
      })
      .addCase(sendFeedback.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: false,
          //error: action.payload.message,
        };
      })
      .addCase(WhistleBlowing.pending, (state, action) => {
        return {
          ...state,
          isLoading: true,
          isSuccessful: false,
        };
      })
      .addCase(WhistleBlowing.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
        };
      })
      .addCase(WhistleBlowing.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: false,
          //error: action.payload.message,
        };
      });
  },
});

export default feedbackSlice.reducer;
